import { Switch, withStyles } from "@material-ui/core";

const MotorplaySwitch = withStyles({
  switchBase: {
    color: '#000000',
    '&$checked': {
      color: '#000000',
    },
    '&$checked + $track': {
      backgroundColor: '#FFB500',
      opacity: 1
    },
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid #030c17d4`,
    backgroundColor: '#FFB500',
    opacity: 1,
  },
  checked: {},
})(Switch);

export default MotorplaySwitch;